import { base } from "../base";

async function addNew(data) {
  return base.post("services/quotation", data);
}

async function update(data) {
  return base.put("services/quotation", data);
}

async function getList(data) {
  return base.get("services/quotation", data);
}

async function updateDetail(data) {
  return base.put("services/quotation/detail", data);
}

async function createDetail(data) {
  return base.post("services/quotation/detail", data);
}


export const quotationService = {
  addNew,
  update,
  getList,
  updateDetail,
  createDetail
};
